//import $ from 'jquery';

const
  NAME               = 'selectRedirect',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

class SelectRedirect {
  constructor(element$) {
    element$.on('change', this.onChange.bind(this));
  }

  onChange(event) {
    window.location = event.target.value;
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(/*config*/) {
    return this.each(function() {
      new SelectRedirect($(this));
    });
  }
}

$.fn[NAME]             = SelectRedirect._jQueryInterface;
$.fn[NAME].Constructor = SelectRedirect;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return SelectRedirect._jQueryInterface;
};

export default SelectRedirect;



// WEBPACK FOOTER //
// ./src/plugins/select-redirect.js